import Container from "@mui/material/Container/Container";
import Stack from "@mui/material/Stack";
import React from "react";
import { AGENDA_CAROUSEL_SECTION } from "../../../util/constants";
import { classes, StyledSectionWrapper } from "./styles";

const Item = ({ fileName }: { fileName: string }) => {
  const imgSrc = "/images/agenda/" + fileName;

  return (
    <div
      style={{
        width: 1000,
        margin: "auto",
      }}
    >
      <img
        style={{
          width: "100%",
          height: "auto",
          // maxHeight: 450,
        }}
        width={900}
        height={614}
        src={imgSrc}
        alt={fileName}
      />
    </div>
  );
};

const AgendaVideo = () => {
  return (
    <StyledSectionWrapper sectionId={AGENDA_CAROUSEL_SECTION}>
      <Stack alignItems="center" sx={{ borderWidth: 0 }}>
        <video
          style={{
            width: "100%", // prend toute la largeur dispo
            maxWidth: "900px", // mais pas plus que 900px
            height: "auto", // garde le ratio
          }}
          poster="/images/absences/innovance-solutions-poster.png"
          controls
          controlsList="nodownload" // cache le bouton téléchargement
          onContextMenu={(e) => e.preventDefault()}
        >
          <source
            src="/videos/agenda/innovance-solutions-agenda-video.mp4"
            type="video/mp4"
          />
          Votre navigateur ne supporte pas la balise vidéo.
        </video>
      </Stack>
    </StyledSectionWrapper>
  );
};

export default AgendaVideo;
